export class CsrfTokenDialogState {
    isOpen: boolean = false;
}
